import { EtState, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|ECommerce|E-Transaction State`;

export type CPETransactionStateLocs =
	| 'CPETransactionStateEnumFailure'
	| 'CPETransactionStateEnumPending'
	| 'CPETransactionStateEnumSuccess'
	| 'CPETransactionStateEnumVoid';

export type SPETransactionStateLocs =
	| 'SPETransactionStateEnumFailure'
	| 'SPETransactionStateEnumPending'
	| 'SPETransactionStateEnumSuccess'
	| 'SPETransactionStateEnumVoid';

export const cpETransactionStateEnumLocs: LocDefs<CPETransactionStateLocs> = {
	CPETransactionStateEnumFailure: {
		defaultValue: 'Failure',
		displayPath: `${dpRoot}|${EtState.Failure}`,
		description: `System value for e-transaction status: '${EtState.Failure}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
	CPETransactionStateEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${dpRoot}|${EtState.Pending}`,
		description: `System value for e-transaction status: '${EtState.Pending}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
	CPETransactionStateEnumSuccess: {
		defaultValue: 'Success',
		displayPath: `${dpRoot}|${EtState.Success}`,
		description: `System value for e-transaction status: '${EtState.Success}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
	CPETransactionStateEnumVoid: {
		defaultValue: 'Void',
		displayPath: `${dpRoot}|${EtState.Void}`,
		description: `System value for e-transaction status: '${EtState.Void}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
};

export const spETransactionStateEnumLocs: LocDefs<SPETransactionStateLocs> = {
	SPETransactionStateEnumFailure: {
		defaultValue: 'Failure',
		displayPath: `${dpRoot}|${EtState.Failure}`,
		description: `System value for e-transaction status: '${EtState.Failure}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
	SPETransactionStateEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${dpRoot}|${EtState.Pending}`,
		description: `System value for e-transaction status: '${EtState.Pending}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
	SPETransactionStateEnumSuccess: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}|${EtState.Success}`,
		description: `System value for e-transaction status: '${EtState.Success}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
	SPETransactionStateEnumVoid: {
		defaultValue: 'Void',
		displayPath: `${dpRoot}|${EtState.Void}`,
		description: `System value for e-transaction status: '${EtState.Void}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
};

const E_TRANSACTION_STATE_LOCS = MapLocKeys<CPETransactionStateLocs | SPETransactionStateLocs>({
	...cpETransactionStateEnumLocs,
	...spETransactionStateEnumLocs,
});

export type CPETransactionStateEnumLocType = LocMap<CPETransactionStateLocs>;
export type SPETransactionStateEnumLocType = LocMap<SPETransactionStateLocs>;

export const cpETransactionStateKeys: { [key in EtState]: keyof CPETransactionStateEnumLocType } = {
	[EtState.Failure]: E_TRANSACTION_STATE_LOCS.CPETransactionStateEnumFailure,
	[EtState.Pending]: E_TRANSACTION_STATE_LOCS.CPETransactionStateEnumPending,
	[EtState.Success]: E_TRANSACTION_STATE_LOCS.CPETransactionStateEnumSuccess,
	[EtState.Void]: E_TRANSACTION_STATE_LOCS.CPETransactionStateEnumVoid,
};

export const spETransactionStateKeys: { [key in EtState]: keyof SPETransactionStateEnumLocType } = {
	[EtState.Failure]: E_TRANSACTION_STATE_LOCS.SPETransactionStateEnumFailure,
	[EtState.Pending]: E_TRANSACTION_STATE_LOCS.SPETransactionStateEnumPending,
	[EtState.Success]: E_TRANSACTION_STATE_LOCS.SPETransactionStateEnumSuccess,
	[EtState.Void]: E_TRANSACTION_STATE_LOCS.SPETransactionStateEnumVoid,
};
